import React from 'react';
import { Link } from 'react-router-dom';
import { usePageContent } from '../../hooks/usePageContent';
import useMeta from '../../hooks/useMeta';
import useTitle from '../../hooks/useTitle';

const NewsEventsPage = () => {
  const { find, meta } = usePageContent('news-events');
  const seo = meta?.seo;
  useTitle(seo?.title || 'News and Events');
  useMeta(seo);
  const c = find('newsEvents') || {};
  const articles = c.articles || [];

  return (
    <div id="content">
      <div className="page-header">
        <div className="container">
          <h1 className="page-header__title">{c.pageTitle || 'News and Events'}</h1>
        </div>
      </div>
      <div className="content-holder content-holder--indented">
        {articles.length === 0 ? (
          <p>{c.comingSoonText || 'Check back soon for the latest news and events from VicRoads Custom Plates.'}</p>
        ) : (
          articles.map((article) => (
            <div key={article.slug} className="news__item">
              <div className="news__item-content">
                <h2 className="news__item-headline">
                  <Link to={`/news-and-events/${article.slug}`} className="news__item-headline-link">
                    {article.headline}
                  </Link>
                </h2>
                <div className="news__item-date">{article.date}</div>
                <p className="news__item-text">{article.excerpt}</p>
                <Link to={`/news-and-events/${article.slug}`} className="news__item-more">
                  {c.readMoreText || 'Read more'}
                </Link>
              </div>
              {article.image && (
                <div className="news__item-media">
                  <img
                    src={article.image}
                    alt=""
                    width={article.imageWidth}
                    height={article.imageHeight}
                    className="news__item-media-image"
                  />
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NewsEventsPage;
